import { render, staticRenderFns } from "./product-all.vue?vue&type=template&id=dca3a568&scoped=true"
import script from "./product-all.vue?vue&type=script&lang=js"
export * from "./product-all.vue?vue&type=script&lang=js"
import style0 from "./product-all.vue?vue&type=style&index=0&id=dca3a568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca3a568",
  null
  
)

export default component.exports